// client code is ES6 Module
import 'text-encoding-utf-8/lib/encoding';
import { Observable } from 'relay-runtime';
import fetchMultipart from 'fetch-multipart-graphql';
import { extractFiles } from 'extract-files';
import createNetworkError from './src/createNetworkError';
import { GRAPHQL_PATH, QUERY_STRING_HEADER } from './src/constants';

const enablerQueryParams = {};

if (typeof window !== 'undefined') {
    new URLSearchParams(window.location.search).forEach((value, key) => {
        if (key.startsWith('enabler-') || key.startsWith('featureFlag-')) {
            enablerQueryParams[key] = value;
        }
    });
}

export function createFetcher({ getQueries = () => ({}) }) {
    return function fetchQuery(operation, variables) {
        return new Observable(sink => {
            const queryString = new URLSearchParams({
                ...enablerQueryParams,
                ...getQueries(),
            }).toString();

            let body;
            const headers = {
                [QUERY_STRING_HEADER]: queryString,
            };
            const operations = { variables };
            if (operation.id) {
                // persisted query support
                operations.id = operation.id;
            } else {
                operations.query = operation.text;
            }
            const { clone: extractedOperations, files } = extractFiles(operations);

            if (files.size) {
                if (!window.FormData) {
                    throw new Error('Uploading files without `FormData` not supported.');
                }

                const formData = new FormData();
                formData.append('operations', JSON.stringify(extractedOperations));

                const pathMap = {};
                let i = 0;
                files.forEach(paths => {
                    pathMap[++i] = paths;
                });
                formData.append('map', JSON.stringify(pathMap));

                // using a separate forEach here to properly order multipart fields
                // files should follow 'map', set in the loop above
                i = 0;
                files.forEach((paths, file) => {
                    formData.append(++i, file, file.name);
                });

                body = formData;
            } else {
                headers['Content-Type'] = 'application/json';
                body = JSON.stringify(operations);
            }

            fetchMultipart(GRAPHQL_PATH, {
                method: 'post',
                headers,
                credentials: 'same-origin', // to ensure cookies send correctly see https://github.com/github/fetch#caveats
                body,
                onNext: payloads => {
                    let hasErrors = false;
                    for (const payload of payloads) {
                        if (payload.errors) {
                            hasErrors = true;
                            if (window.newrelic) {
                                payload.errors.forEach(e => window.newrelic.noticeError(e));
                            }
                            // all errors are critical, throw so relay treats as an error
                            const error = createNetworkError(operation, payload);
                            sink.error(error);
                        }
                    }
                    if (!hasErrors) {
                        sink.next(payloads);
                    }
                },
                onError: err => sink.error(err),
                onComplete: () => sink.complete(),
            });
        });
    };
}
